import { assertUint32 } from '../shared/invariants';

export interface RandomSource {
  next(): number;
  clone(): RandomSource;
}

/**
 * Exact Mulberry32 implementation. The state advances with unsigned 32-bit
 * arithmetic and clone() resumes at the identical sequence position.
 */
export class Mulberry32 implements RandomSource {
  private state: number;

  public constructor(seed: number) {
    assertUint32(seed, 'seed');
    this.state = seed >>> 0;
  }

  public next(): number {
    this.state = (this.state + 0x6d2b_79f5) >>> 0;
    let value = this.state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4_294_967_296;
  }

  public clone(): Mulberry32 {
    return new Mulberry32(this.state);
  }

  public getState(): number {
    return this.state;
  }
}
